export const DISCORD_URL = "https://discord.gg/MASTERKR";

export const SERVERS = [
  {
    id: "chernarus",
    name: "BRASIL + CHERNARUS",
    map: "Chernarus",
    url: "https://dayzbrasil.com.br/",
    tagline: "O mapa clássico",
    description:
      "Florestas densas, vilarejos abandonados e bases militares disputadas. A experiência DayZ original.",
    accent: "#c81e1e",
    image: "/assets/banner-chernarus.webp",
  },
  {
    id: "nasdara",
    name: "BRASIL + NASDARA",
    map: "Nasdara",
    url: "https://brasil-nasdara.dayz-rss.com/",
    tagline: "Território árido",
    description:
      "Desertos escaldantes, cidades de areia e combate a céu aberto. Um novo desafio para sobreviventes.",
    accent: "#c81e1e",
    image: "/assets/banner-nasdara.webp",
  },
];

export const LOGO_URL = "/assets/logo-brasil-red.webp";
export const LOGO_ALT_URL = "/assets/logo-brasil-green.webp";
